exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-form td[data-v-0fbef908]:last-child{border-right:none}.table-form .table-body[data-v-0fbef908]{word-break:break-all;font-size:14px}.table-form .table-body tr[data-v-0fbef908]:last-child{border:none}.table-form .table-body td[data-v-0fbef908]:first-child{border-left:none}[data-v-0fbef908] .el-card .el-card__header{padding:10px}[data-v-0fbef908] .custom-card{border-bottom:none!important}[data-v-0fbef908] .el-card .el-card__header{padding:0!important}", ""]);

// exports
